import React from "react";
import Particle from "../Particle";
import { Container } from "react-bootstrap";
import "./style.css";

function Comingsoon() {
  return (
    <section>
      <Container fluid className="home-section" id="Comingsoon">
        <Particle />
        <Container className="home-content">
          <div className="Comingsoon">
            <div className="title">Coming Soon</div>
            <div className="subtitle">We are working on something amazing!</div>
            <div className="animation-container">
              <div className="circle-container">
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="circle"></div>
              </div>
              <div className="circle-big"></div>
            </div>
          </div>
        </Container>
      </Container>
    </section>
  );
}

export default Comingsoon;
